export default class Modules {
  /**
   * Delegates to the legacy WebPOS function until we decide to subsume that behaviour
   * entirely here.
   *
   * @param {string} moduleName   The module name
   */
  static hasModule(moduleName: ModuleName) {
    return window.lsCloud.Modules.hasModule(moduleName);
  }
}
